<template>
  <div class="page_">
    <div class="pageBanner_">
      <div class="container">
        <div class="title_">版权授权从未如此简单</div>
        <div class="comments_">
          <div class="commentsTitle">
            彻底改变作品使用权的交易方式
          </div>
          <div class="starContainer">
            <div class="scoreList">
              <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
              <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
              <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
              <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
              <img src="../../assets/images/staticPage/homePage/star1.png" alt="">
            </div>
            4.5星/5星 323602评论
          </div>
        </div>

        <div class="txt">
          限时 0 交易费
        </div>

        <div class="button" @click="pageJump('/contentChain')">
          开始
        </div>
      </div>
    </div>

    <div class="introduce_">
      一个作品拥有很多不同的法律权利，了解这些权利非常重要，因为如果过度授权会影响您作品未来其他渠道的收益，但如果提供的授权太少，满足不了一些互联网或出版社的基本要求，会造成使用方无法使用您的版权
    </div>

    <div class="iconList">
      <div class="item">
        <img src="../../assets/images/staticPage/rightsProtectionService/icon1.png" alt="">
        只有你提交的出版方可以阅读到你的作品
      </div>
      <div class="item">
        <img src="../../assets/images/staticPage/rightsProtectionService/icon2.png" alt="">
        您可以设置只开放部分预览内容，只有购买后才可以完整阅读
      </div>
      <div class="item">
        <img src="../../assets/images/staticPage/rightsProtectionService/icon3.png" alt="">
        稿酬和版税收益立即到账
      </div>
      <div class="item">
        <img src="../../assets/images/staticPage/rightsProtectionService/icon4.png" alt="">
        面对不同的出版社进行差异化授权和定价
      </div>
      <div class="item">
        <img src="../../assets/images/staticPage/rightsProtectionService/icon5.png" alt="">
        无需和使用方沟通<br />所有的交易信息都完备
      </div>
    </div>

    <div class="bottomContainer">
      <div class="title_">
        登记作品之后非常简单
      </div>
      <div class="container" style="width:100%">
        <div class="left_">
          <div class="item">
            <div>可以授权的权利和定价</div>
            <div>您可以提供多种设置，比如常规定价和面对某一个特定出版社的特殊定价和授权组合</div>
          </div>
          <div class="item">
            <div>生成您的作品专属链接</div>
            <div>您可以设定链接的有效时间、预览比例；甚至也可以设定预览密码</div>
          </div>
          <div class="item">
            <div>版权使用方购买后，版权费用马上到账</div>
            <div>版权方可以根据您设定的不同权利的不同价格选择购买，购买后金额将马上到账，您无需支付任何手续费。</div>
          </div>
        </div>
        <div class="right_">
          <img src="../../assets/images/staticPage/rightsProtectionService/banner.png" alt="">
        </div>
      </div>
    </div>
    <marketingPageFooter></marketingPageFooter>
  </div>
</template>
<script>
import { reactive } from "vue";
import marketingPageFooter from '@/components/marketingPageFooter.vue'
import { useRouter } from "vue-router";
// import { useStore } from "vuex";
// import Cookies from "js-cookie";

export default {
  name: "rightsProtectionService",
  components: {
    marketingPageFooter
  },
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    const router = useRouter();
    // const store = useStore();
    let pageData = reactive({

    })
    const pageJump = (e) => {
      router.push(e);
    };
    return {
      pageData,
      pageJump
    };
  },
};
</script>
<style lang='scss' scoped>
.page_ {
  display: flex;
  flex-direction: column;
  align-items: center;

  .bottomContainer {
    margin: 80px 0 88px;

    .container {
      display: flex;
      align-items: center;
      justify-content: center;

      .right_ {
        width: 464px;
        margin-left: 37px;

        img {
          width: 100%;
        }
      }

      .left_ {
        width: 456px;
        cursor: pointer;

        .item:hover {
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1), inset 8px 0px 0px 0px #008AEA;
        }

        .item {
          width: 465px;
          padding: 30px;
          box-sizing: border-box;
          transition: .5s all;

          div:nth-of-type(1) {
            font-size: 18px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
            font-weight: 600;
          }

          div:nth-of-type(2) {
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: #303133;
            line-height: 20px;
            margin-top: 8px;
          }
        }
      }
    }

    .title_ {
      font-size: 40px;
      font-family: AlibabaPuHuiTiB;
      color: #303133;
      text-align: center;
      margin-bottom: 40px;
    }
  }

  .iconList {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .item:last-child {
      margin: 0;
    }

    .item {
      width: 160px;
      text-align: center;
      font-size: 14px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
      line-height: 20px;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 40px;
      font-weight: 500;

      img {
        width: 80px;
        margin-bottom: 8px;
      }
    }
  }

  .introduce_ {
    width: 700px;
    font-size: 18px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    line-height: 28px;
    text-align: center;
    letter-spacing: .1em;
    margin: 80px 0;
  }

  .pageBanner_ {
    width: 100%;
    height: 500px;
    background: url('../../assets/images/staticPage/rightsProtectionService/bannerImg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .txt {
      font-size: 24px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      font-weight: 600;
    }

    .button {
      width: 200px;
      height: 48px;
      background: #008AEA;
      border-radius: 8px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      margin-top: 24px;
      cursor: pointer;
    }

    .container {
      width: 530px;
      margin-right: 12.5%;

      .comments_ {
        margin: 16px 0 24px;

        .starContainer {
          width: 100%;
          padding: 8px 0 24px;
          box-sizing: border-box;
          border-bottom: 1px #909399 solid;
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #008AEA;

          .scoreList {
            display: flex;
            align-items: center;
            margin-right: 4px;

            img {
              width: 24px;
            }
          }
        }

        .commentsTitle {
          font-size: 18px;
          font-family: AlibabaPuHuiTiM;
          color: #008AEA;
        }
      }

      .title_ {
        font-size: 36px;
        font-family: AlibabaPuHuiTiB;
        color: #303133;
        font-weight: 700;
      }
    }
  }
}
</style>
